import App from "../../services/App/App.js";
import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";
import RouterModel from "../../router/RouterModel.js";

import HpadD from "./Details/HpadD.vue";
import HpadExL from "./ExportList/HpadExL.vue";
import HpadL from "./List/HpadL.vue";
import HpadN from "./New/HpadN.vue";
import HpadPD from "./PrintDetails/HpadPD.vue";
import HpadPL from "./PrintList/HpadPL.vue";

export default {
  Path: {
    Details: RouterModel.getPath(AppModule.HppAdj, AppModuleType.Details),
    List: RouterModel.getPath(AppModule.HppAdj, AppModuleType.List),
    New: RouterModel.getPath(AppModule.HppAdj, AppModuleType.New),
    PrintDetails: RouterModel.getPath(AppModule.HppAdj, AppModuleType.PrintDetails),
    PrintList: RouterModel.getPath(AppModule.HppAdj, AppModuleType.PrintList)
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.Details),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.Details),
        component: HpadD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.Details),
          module: RouterModel.getModule(AppModule.HppAdj),
          moduleattr: AppModuleAttr.HppAdj_Act_Details,
          moduletype: AppModuleType.Details
        }
      },
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.ExportList),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.ExportList),
        component: HpadExL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.ExportList),
          module: RouterModel.getModule(AppModule.HppAdj),
          moduleattr: AppModuleAttr.HppAdj_Act_ExportList,
          moduletype: AppModuleType.ExportList
        }
      },
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.List),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.List),
        component: HpadL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.List),
          module: RouterModel.getModule(AppModule.HppAdj),
          moduleattr: AppModuleAttr.HppAdj_Act_List,
          moduletype: AppModuleType.List,
          // actions
          exportlist: {
            module: RouterModel.getModule(AppModule.HppAdj),
            moduleattr: AppModuleAttr.HppAdj_Act_ExportList,
            moduletype: AppModuleType.ExportList
          },
          new: {
            module: RouterModel.getModule(AppModule.HppAdj),
            moduleattr: AppModuleAttr.HppAdj_Act_New,
            moduletype: AppModuleType.New
          },
          printlist: {
            module: RouterModel.getModule(AppModule.HppAdj),
            moduleattr: AppModuleAttr.HppAdj_Act_PrintList,
            moduletype: AppModuleType.PrintList
          }
        }
      },
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.New),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.New),
        component: HpadN,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.New),
          module: RouterModel.getModule(AppModule.HppAdj),
          moduleattr: AppModuleAttr.HppAdj_Act_New,
          moduletype: AppModuleType.New,
          cancel: {
            url: RouterModel.getPath(AppModule.HppAdj, AppModuleType.List)
          },
          submit: {
            url: RouterModel.getPath(AppModule.HppAdj, AppModuleType.Details),
            params: {
              [App.Enum.Param.ID]: [App.Enum.Response.ID]
            }
          }
        }
      },
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.PrintDetails),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.PrintDetails),
        component: HpadPD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.PrintDetails),
          module: RouterModel.getModule(AppModule.HppAdj),
          moduleattr: AppModuleAttr.HppAdj_Act_PrintDetails,
          moduletype: AppModuleType.PrintDetails
        }
      },
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.PrintList),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.PrintList),
        component: HpadPL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.PrintList),
          module: RouterModel.getModule(AppModule.HppAdj),
          moduleattr: AppModuleAttr.HppAdj_Act_PrintList,
          moduletype: AppModuleType.PrintList
        }
      }
    ];
  }
}